import React, { useState, useEffect } from "react";
import {
  Button,
  Box,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  PaginationItem,
  Alert,
  Snackbar,
  DialogTitle,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AddConsumptionByEquipment from "./AddConsumptionByEquipment";
import ViewConsumption from "./ViewConsumption";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import { get, api, del } from "../../../../utils/api";
import DateRangePickerComponent from "../../../Masters/Roles and Permissions/Filters/Date";
import MultiSelect from "../../../Masters/Roles and Permissions/Filters/MultiSelect";
import Range from "../../../Masters/Roles and Permissions/Filters/Range";
import { styled } from "@mui/material/styles";
import Cards from "../../../../Components/Common/Cards";
import ViewTable from "../../../../Components/Common/ViewTable";
import MonthYearFilter from "../../../Masters/Roles and Permissions/Filters/MonthYearFilter";
import PaginationBox from "../../../../Components/Masters/Pagination";
import TopMenuUpload from "../../../../Components/Masters/TopMenuUpload";
import BulkUploadModal from "../../../../Components/Common/BulkUploadModal";
import { formatNumber } from "../../../../utils/formatNumber";
import { formatNumberCommaSeparated } from "../../../../utils/common";
import BulkUpload from "../../BulkUploadEquipment";
import { useUser } from "../../../../context/AuthContext";
import DeleteAlertDialog from "../../../../Components/Masters/DeleteAlertDialog";
import {
  mapTableDataWithFacility,
  shouldShowFacilityColumn,
  withFacilityViewTableHeader,
} from "../../../../utils/facilityColumn";

const ElectricityConsumption = () => {
  const { user } = useUser();
  const showFacilityColumn = shouldShowFacilityColumn(user);
  const [petroleums, setPetroleums] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [element, setElement] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [uniqueValues, setUniqueValues] = useState({});
  const [selectedFields, setSelectedFields] = useState({
    equipment: [],
  });
  const [appliedFilters, setAppliedFilters] = useState({
    date: false,
    equipment: false,
    quantityConsumed: false,
    hoursUsed: false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [view, setView] = useState(false);
  const [dataView, setdataView] = useState(null);
  const [dataforView, setdataForView] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [unitOfConsumption, setUnitOfConsumption] = useState({
    min: "",
    max: "",
  });
  // const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [selectedCountries, setSelectedCountries] = useState([]); // Store selected countries
  const [selectedFacilities, setSelectedFacilities] = useState([]); // Store selected petroleum name
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [startMonth, setStartMonth] = useState(null);
  const [endMonth, setEndMonth] = useState(null);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [selectedPeriod, setSelectedPeriod] = React.useState("July");

  const months = {
    1: { start: "January", end: "March", description: "Q1" }, // Quarter 1
    2: { start: "April", end: "June", description: "Q2" }, // Quarter 2
    3: { start: "July", end: "September", description: "Q3" }, // Quarter 3
    4: { start: "October", end: "December", description: "Q4" }, // Quarter 4
  };
  const [errors, setErrors] = useState({
    Date: false,
    equipment: false,
    quantityConsumed: false,
    hoursUsed: false,
  });
  const [quantityRange, setQuantityRange] = useState({ min: "", max: "" });
  const [hoursRange, setHoursRange] = useState({ min: "", max: "" });
  const [cardConsumptions, setCardConsumptions] = useState({
    "Total Petrol Consumed": "",
    "Top Equipment By Consumption": "",
    "Consumption Period": "",
  });

  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    startMonth: null,
    endMonth: null,
    equipment: [],
    unitOfConsumption: { min: "", max: "" },
  });

  const [cardData, setCardData] = useState({});
  const [filter, setFilters] = useState({});

  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);
  const [formData, setFormData] = useState({});
  const [bulkUploadTable, setBulkUploadTable] = useState(true);
  const [formDataBulkUpload, setFormDataBulkUpload] = useState({});
  const [matchData, setMatchData] = useState([]);
  const [equipmentData, setEquipmentData] = useState([]);

  const equipmentList = async () => {
    const response = await get(`/master/Steam/Equipement`);
    console.log(response.data.data, " equipmentList");
    setEquipmentData(response.data.data.map((item) => item.equipment));
    return response.data.data.map((item) => item.equipment);
  };
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [equipment] = await Promise.all([equipmentList()]);

        console.log(equipment, "Final Equipment List");

        // Optionally store them in state

        // Now fetch your excel data
        fetchExcelData();
      } catch (error) {
        console.error("Error fetching equipment or vendors:", error);
      }
    };
    fetchInitialData();
  }, []);

  const fetchExcelData = async () => {
    await get("/scope2/steamEquipment/steam/equipment")
      .then((res) => {
        let data = res.data.data;
        let arr = data.map((el, idx) => {
          return {
            "Month (in 01/25 or Jan-25)": "",
            Equipment: el?.equipment,
            "Hours Used": "",
            "Remark (optional)": "",
          };
        });
        setExcelData(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  const headers = withFacilityViewTableHeader(
    [
      { key: "createdAt", label: "Date", sortable: true, width: "12%" },
      {
        key: "consumptionPeriod",
        label: "Consumption Month",
        sortable: true,
        width: showFacilityColumn ? "14%" : "20%",
      },
      { key: "equipment", label: "Equipment", sortable: true, width: "14%" },
      { key: "brand", label: "Brand", sortable: true, width: "14%" },
      {
        key: "model",
        label: "Model",
        sortable: true,
        width: "15%",
      },
      {
        key: "unitOfConsumption",
        label: "Units Consumed",
        sortable: true,
        truncate: true,
        width: "15%",
      },
    ],
    showFacilityColumn,
    { width: "20%" }
  );
  const quarterMonths = {
    1: "Jan-Mar",
    2: "Apr-Jun",
    3: "Jul-Sep",
    4: "Oct-Dec",
  };

  const inputData = [
    // {
    //   fieldName: "vendor",
    //   title: "Vendor Name",
    //   placeholder: "Tap to select",
    //   type: "select",
    //   url: `${api}/master/Steam/getVendor`,
    //   required: true,
    //   field: "VendorLegalFullName",
    // },
    // {
    //   fieldName: "previousMeterReading",
    //   title: "Previous Reading",
    //   placeholder: "kwh",
    //   type: "number",
    //   required: true,
    // },
    // {
    //   fieldName: "currentMeterReading",
    //   title: "Current  Reading",
    //   placeholder: "kwh",
    //   type: "number",
    //   required: true,
    // },
    {
      fieldName: "consumptionPeriod",
      title: "Consumption Month",
      required: true,
      type: "date",
    },

    {
      fieldName: "equipment",
      title: "Equipment",
      placeholder: "Tap to Select",
      type: "select",
      url: `${api}/master/Steam/Equipement`,
      field: "equipment",
      required: true,
    },
    {
      fieldName: "brand",
      title: "Brand",
      placeholder: "Autofilled",
      type: "text",
    },
    {
      fieldName: "model",
      title: "Model",
      placeholder: "Autofilled",
      type: "text",
    },
    {
      fieldName: "usedHours",
      title: "Hours in use",
      placeholder: " Enter Hours",
      type: "number",
    },
    {
      fieldName: "unitOfConsumption",
      title: "Units Consumed",
      placeholder: "Autofilled",
      type: "text",
    },
    // {
    //   fieldName: "reasonForDeviation",
    //   title: "Reason For Deviation",
    //   placeholder: "reason for any deviation in meter reading",
    //   type: "text",
    // },
    // {
    //   fieldName: "calorificValue.unit",
    // //   title: "Calorific Value Unit",
    //   placeholder: "Select unit",
    //   type: "select",
    //   options: ["MJ/kg", "MJ/m3"],
    //   required: true,
    // },
    {
      fieldName: "remarks",
      title: "Remark (optional)",
      placeholder: "Additional remarks",
      type: "text",
    },
    {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      type: "file",
    },
  ];

  const filters = [
    "Date",
    "Consumption Month",
    "Equipment",
    "Units Consumed (KWH)",
  ];
  let bannerData = [
    {
      title: "Total Steam Consumed",
      description: cardData?.totalSum ? formatNumber(cardData?.totalSum) : 0,
      unit: "KWH",
    },
    {
      title: "Top Steam Consuming Equipment",
      description: cardData?.topEquipment
        ? cardData?.topEquipment?.equipmentName
        : "N/A",
      unit: "KWH",
    },
    {
      title: "Avg. Usage Hours per Equipment",
      description: cardData?.monthly ? formatNumber(cardData?.monthly) : 0,
      filter: "date",
    },
  ];

  const handleFilterChangeCards = (cardTitle, filterValue, type) => {
    console.log(cardTitle, filterValue, type, "databasedOfValue");

    if (type === "date") {
      const [year, month] = filterValue.split("-");
      setFilters((prev) => ({
        ...prev,
        month,
        year,
      }));
      fetchCardData(year, month, "");
    } else if (type === "option") {
      setFilters((prev) => ({
        ...prev,
        [cardTitle]: filterValue,
      }));
      fetchCardData(filterValue);
    } else {
      setFilters((prev) => ({
        ...prev,
        [cardTitle]: filterValue,
      }));
    }
  };

  const fetchCardData = async (year, month) => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    try {
      console.log("year", year, month);

      const response = await get(`/scope2/steamEquipment/cardData`, {
        params: {
          // year, month,
          year: selectedYear ? selectedYear : currentYear,
          month: selectedMonth ? selectedMonth : currentMonth + 1,
          //  equipment: equipment
        },
      });
      if (response) {
        const result = Object.keys(months)
          .map((item) => {
            if (Number(item) === response.data.data.peakConsumption.quarter) {
              return `${months[item].start} - ${months[item].end},${response.data.data.peakConsumption.year}`;
            }
          })
          .filter(Boolean)[0];
        console.log(
          response.data.data,
          Object.keys(months),
          result,
          response.data.data.peakData,
          "cardData"
        );

        setCardData({
          ...cardData,
          monthly:
            response.data.data.monthlySum.length > 0
              ? response.data.data.monthlySum.map(
                  (item) => item.totalConsumption
                )
              : 0,
          // monthly: response.data.data.monthlySum.map(item => item.totalConsumption),
          //  totalConsumption: response.data.data.total.map((item)=>item.totalConsumption),
          totalSum: response.data.data.totalSum.map(
            (item) => item.totalConsumption
          ),
          topEquipment: response.data.data.topEquipment,
          peakConsumption: response.data.data.peakConsumption.peakConsumption,
          peakData: response.data.data.peakConsumption,
          peakValue: `${response.data.data.peakConsumption.peakConsumption}kwh`,
          topEquipment: response.data.data.topEquipment,
        });
      }
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  useEffect(() => {
    // const year = selectedDate.year();
    // const month = selectedDate.month() + 1; // Month is 0-indexed in dayjs
    fetchCardData();
  }, [selectedMonth, selectedYear]);

  // Function to render the selected filter component based on user's choice

  const handlePeriodChange = (event) => {
    setSelectedPeriod(event.target.value);
  };

  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
            errors={errors.Date}
          />
        );
      case "Consumption Month":
        return (
          <MonthYearFilter
            title={"Consumption Month"}
            startMonth={tempFilter?.startMonth}
            endMonth={tempFilter?.endMonth}
            setStartMonth={(date) =>
              setTempFilter((prev) => ({ ...prev, startMonth: date }))
            }
            setEndMonth={(date) =>
              setTempFilter((prev) => ({ ...prev, endMonth: date }))
            }
            setErrors={setErrors}
            errors={errors.Date}
          />
        );
      case "Equipment":
        return (
          <MultiSelect
            title="Equipment"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  equipment: newValue.equipment || newValue,
                };
              });
            }}
            errors={errors["Equipment"]}
            setErrors={setErrors}
            field="equipment"
            data={uniqueValues.equipment}
          />
        );
      case "Units Consumed (KWH)":
        return (
          <Range
            title="Units Consumed (KWH)"
            selectedRange={tempFilter.unitOfConsumption}
            setSelectedRange={(range) =>
              setTempFilter((prev) => ({
                ...prev,
                unitOfConsumption: range,
              }))
            }
            errors={errors["Units Consumed (KWH)"]}
            setErrors={setErrors}
            placeholderMax="Max(Units)"
            placeholderMin="Min(Units)"
          />
        );
      case "Hours in Use":
        return (
          <Range
            title="Hours in Use"
            selectedRange={hoursRange}
            setSelectedRange={setHoursRange}
            errors={errors["Hours in Use"]}
            setErrors={setErrors}
            placeholderMax="Max(Hours)"
            placeholderMin="Min(Hours)"
          />
        );
      default:
        return null;
    }
  };

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`/scope2/steamEquipment/getSteamEquipement`);
      const data = response.data.data;
      console.log(data);

      const uniqueEquipmentType = [
        ...new Set(
          data.map((el) => el.equipment?.equipment).filter(Boolean) // Filter out undefined values
        ),
      ];

      const uniqueUnit = [
        ...new Set(
          data.map((el) => el?.unitOfElectricityConsumption).filter(Boolean) // Filter out undefined values
        ),
      ];

      return {
        equipment: uniqueEquipmentType,
        vendor: uniqueEquipmentType,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  const handleMenuClick = (event, data) => {
    setAnchorEl(event.currentTarget);
    // setSelectedPetroleum(petroleum);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    // setSelectedPetroleum(null);
  };

  const handleEdit = (data) => {
    console.log("Edit petroleum:", data?._id, data);
    handleMenuClose();
    setAddData(true);
    setView(false);
    setdataView(data?._id !== undefined ? data : data?.data);
  };

  const handleView = (data) => {
    console.log("View petroleum:");
    handleMenuClose();
    setView(true);
    setAddData(false);
    setdataForView(data?.data);
  };

  const handleDelete = (index) => {
    handleMenuClose();
    setDeleteDialog(true);
    setView(false);
    setdataView(index.id);
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // fetching petroleum data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    // const fetchData = async (filters = {}) => {

    console.log(filters, "");
    try {
      console.log(sortConfig);
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
      }).toString();
      console.log("Query Params sent to API:", queryParams, filters); // Debugging line
      const response = await get(
        `/scope2/steamEquipment/getSteamEquipement?${queryParams}`
      );
      let arr = response?.data?.data?.map((item) => {
        return {
          createdAt: new Date(item.createdAt).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }),
          //   unitOfConsumption: item?.unitOfConsumption,
          // usedHours: item.usedHours,
          unitOfConsumption: item?.unitOfConsumption,
          model: item.model,
          equipment: item.equipment?.equipment,
          brand: item.brand,
          action: "View",
          id: item?._id,
          data: item,
        };
      });
      console.log(arr, "for ListData");
      setTableData(arr);
      console.log(
        "Fetched data after filtering:",
        response.data,
        response.data.data,
        response.data.totalPages
      ); // Debugging line
      fetchCardData(selectedMonth, selectedMonth);
      setPetroleums(response.data.data); // Update the user list
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData(filtersToApply);
    // fetchData()
  }, [page, rowsPerPage, sortConfig]);

  // default filters to apply
  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    startMonth: tempFilter?.startMonth
      ? tempFilter?.startMonth.format("YYYY-MM-DD")
      : "",
    endMonth: tempFilter?.endMonth
      ? tempFilter?.endMonth.format("YYYY-MM-DD")
      : "",
    equipment: tempFilter?.equipment.join(","),
    ...(tempFilter.unitOfConsumption.min
      ? { minUnits: tempFilter.unitOfConsumption.min }
      : {}),
    ...(tempFilter.unitOfConsumption.max
      ? { maxUnits: tempFilter.unitOfConsumption.max }
      : {}),
  };
  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = {
      Date: false,
      "Units Consumed (KWH)": false,
      Equipment: false,
    };

    console.log(selectedFilter, "hi");

    if (selectedFilter === "Date") {
      const today = new Date(); // Get the current date
      // if (!startDate && !endDate) {
      //   newErrors.Date = "Please select start date & end date";
      //   isValid = false;
      // }
      // Ensure that startDate and endDate are not greater than today's date
      if (startDate && startDate > today) {
        newErrors.Date = "Start date cannot be in the future";
        isValid = false;
      }

      if (endDate && endDate > today) {
        newErrors.Date = "End date cannot be in the future";
        isValid = false;
      }

      // Ensure that the startDate is less than or equal to the endDate
      if (startDate && endDate && startDate > endDate) {
        newErrors.Date = "End date must be greater than Start date";
        isValid = false;
      }
    }
    if (selectedFilter === "Quantity Consumed") {
      const min = parseFloat(quantityRange.min);
      const max = parseFloat(quantityRange.max);

      if (min && isNaN(min)) {
        newErrors["Quantity Consumed"] =
          "Min consumption must be a valid number";
        isValid = false;
      }

      if (max && isNaN(max)) {
        newErrors["Quantity Consumed"] =
          "Max consumption must be a valid number";
        isValid = false;
      }

      if (!isNaN(min) && !isNaN(max) && min > max) {
        newErrors["Quantity Consumed"] =
          "Max value should be greater than Min value";
        isValid = false;
      }
    }
    if (selectedFilter === "Quantity Consumed") {
      const min = parseFloat(quantityRange.min);
      const max = parseFloat(quantityRange.max);

      if (min && isNaN(min)) {
        newErrors["Quantity Consumed"] =
          "Min consumption must be a valid number";
        isValid = false;
      }

      if (max && isNaN(max)) {
        newErrors["Quantity Consumed"] =
          "Max consumption must be a valid number";
        isValid = false;
      }

      if (!isNaN(min) && !isNaN(max) && min > max) {
        newErrors["Quantity Consumed"] =
          "Max value should be greater than Min value";
        isValid = false;
      }
    }
    // if (
    //   selectedFilter === "Equipment" &&
    //   selectedFields?.equipment?.length === 0
    // ) {
    //   newErrors["Equipment"] = "Please select atleast one Equipment";
    //   isValid = false;
    // }

    if (selectedFilter === "Hours Used") {
      const min = parseFloat(hoursRange.min);
      const max = parseFloat(hoursRange.max);

      if (!min && !max) {
        newErrors["Hours Used"] = "Please provide both min and max values";
        isValid = false;
      }

      if (min && isNaN(min)) {
        newErrors["Hours Used"] = "Min hours must be a valid number";
        isValid = false;
      }

      if (max && isNaN(max)) {
        newErrors["Hours Used"] = "Max hours must be a valid number";
        isValid = false;
      }

      if (!isNaN(min) && !isNaN(max) && min > max) {
        newErrors["Hours Used"] =
          "Min hours cannot be greater than max consumption";
        isValid = false;
      }
    }
    if (selectedFilter === "Units Consumed (KWH)") {
      const min = parseFloat(unitOfConsumption.min);
      const max = parseFloat(unitOfConsumption.max);

      console.log("minm", min, max, unitOfConsumption.min);

      //   if ((min !== "" && min !== undefined && isNaN(Number(min))) ||
      //   (max !== "" && max !== undefined && isNaN(Number(max)))) {
      //     newErrors["Units Consumed (KWH)"] = "Please provide valid min and max values";
      //     isValid = false;
      // } else
      if (min < 0 || max < 0) {
        newErrors["Units Consumed (KWH)"] =
          "Min or Max values cannot be negative";
        isValid = false;
      } else if (min > max) {
        newErrors["Units Consumed (KWH)"] =
          "Min value cannot be greater than Max value";
        isValid = false;
      }
    }
    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    if (!validateFilters()) return;
    console.log("Applying filters...");

    // Reset to first page when applying filters
    setStartDate(tempFilter.startDate);
    setEndDate(tempFilter.endDate);
    setStartMonth(tempFilter.startMonth);
    setEndMonth(tempFilter.endMonth);
    setSelectedFields({
      equipment: tempFilter.equipment,
    });
    setUnitOfConsumption(tempFilter.unitOfConsumption);
    setPage(1);
    fetchData(filtersToApply);
    setDrawerFilterOpen(false);
    handleAppliedFilters();
  };

  const handleResetFilters = async () => {
    setTempFilter({
      startDate: null,
      endDate: null,
      endMonth: null,
      startMonth: null,
      equipment: [],
      unitOfConsumption: { min: "", max: "" },
    });

    setStartDate(null);
    setEndDate(null);
    setStartMonth(null);
    setEndMonth(null);
    setSelectedFields({
      equipment: [],
    });
    setUnitOfConsumption({ min: "", max: "" });

    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = tempFilter?.startDate || tempFilter?.endDate;
    const isConsumptionMonth = tempFilter?.startMonth || tempFilter?.endMonth;
    const isEquipmentTypeApplied = selectedFields.vendor?.length > 0;
    // const isEquipmentApplied = selectedFields.equipment?.length > 0;
    const isEquipmentApplied = tempFilter?.equipment?.length > 0;

    const isUnitRangeApplied =
      tempFilter.unitOfConsumption.min || tempFilter.unitOfConsumption.max;

    setIsFiltersApplied(
      isDateApplied ||
        isConsumptionMonth ||
        isEquipmentTypeApplied ||
        isUnitRangeApplied ||
        isEquipmentApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      "Consumption Month": isConsumptionMonth,
      Equipment: isEquipmentApplied,
      "Units Consumed (KWH)": isUnitRangeApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      equipment: selectedFields.equipment,
      unitOfConsumption: {
        min: unitOfConsumption.min,
        max: unitOfConsumption.max,
      },
    });
    setDrawerFilterOpen(false);
    // setErrors({ Date: false, Role: false });
  };

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
  };

  const uploadErrorClose = () => {
    setBulkUploadTable(true);
  };

  const handleOpenFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      equipment: selectedFields.equipment,
      unitOfConsumption: tempFilter.unitOfConsumption,
    });
    setDrawerFilterOpen(true);
  };

  

  return (
    <Box
      sx={{
        backgroundColor: "#ededed",
      }}
    >
      <Snackbar
        open={snackOpen.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          // onClose={handleClose}
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
          {/* Add user Successfully */}
        </Alert>
      </Snackbar>

      <AddConsumptionByEquipment
        addData={addData}
        setAddData={setAddData}
        id={dataView ? dataView._id : ""}
        SelectedData={dataView}
        fetchData={fetchData}
        inputData={inputData}
        addUrl={`${api}/scope2/steamEquipment/addSteamEquipement`}
        updateUrl={`${api}/scope2/steamEquipment/updateSteamEquipement`}
        setsnackOpen={setsnackOpen}
      />
      <ViewConsumption
        view={view}
        setView={setView}
        selectedData={dataforView}
        handleEdit={handleEdit}
        companyAdmin={user?.companyAdmin}
      />

      <Cards
        data={bannerData}
        title={"Steam"}
        onFilterChange={handleFilterChangeCards}
        {...{ setSelectedMonth, setSelectedYear, selectedMonth, selectedYear }}
      />
    
      {deleteDialog && (
        <DeleteAlertDialog
          {...{
            deleteDialog,
            setDeleteDialog,
            method: "delete",
            id: dataView,
            url: `${api}/scope2/steamEquipment/deleteSteamEquipement`,
            setsnackOpen,
            fetchData,
            fetchCardData,
          }}
        />
      )}

      <Box>
        {drawerFilterOpen && (
          <FilterDrawer
            {...{
              renderSelectedFilter,
              drawerFilterOpen,
              setDrawerFilterOpen,
              handleApplyFilters,
              handleFilterDrawer,
              setSelectedFilter,
              handleResetFilters,
              selectedFilter,
              filters,
              appliedFilters,
              selectedFields,
              setSelectedFields,
            }}
          />
        )}{" "}
        {/* Top Box for Heading, Filter Button, Add Data Button */}
        <TopMenuUpload
          setData={setdataView}
          setAddData={setAddData}
          {...{
            // heading: "Coal",
            setBulkUploadModal,
            setDrawerFilterOpen: handleOpenFilterDrawer,
            filterApplied: isFiltersApplied,
          }}
        />
      </Box>

      <ViewTable
        headers={headers}
        data={mapTableDataWithFacility(tableData, showFacilityColumn)}
        title={"Consumption By Equipment"}
        onSort={handleSort}
        sortConfig={sortConfig}
        onMenuClick={handleMenuClick}
        editIcon={user?.companyAdmin ? "disable" : "enable"}
        page={2}
        count={10}
        onPageChange={() => {
          console.log("first");
        }}
        onView={handleView}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
      {totalPages > 1 && (
        <PaginationBox
          {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
        />
      )}

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            width: "120px",
            border: "1px solid #ddd",
            marginLeft: "-47px",
          },
        }}
      >
        <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
          <AssignmentIcon sx={{ marginRight: "8px", fontSize: "large" }} /> View
          Logs
        </MenuItem>
        <MenuItem onClick={handleEdit} sx={{ fontSize: "14px" }}>
          <EditIcon sx={{ marginRight: "8px", fontSize: "large" }} /> Edit
        </MenuItem>

        <MenuItem onClick={handleDelete} sx={{ fontSize: "14px" }}>
          <DeleteIcon sx={{ marginRight: "8px", fontSize: "large" }} /> Delete
        </MenuItem>
      </Menu>

      {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={handleCloseBulkUpload}
          isBulkUploadModal={bulkUploadModal}
          setsnackOpen={setsnackOpen}
          excelData={excelData}
          formDataBulkUpload={formDataBulkUpload}
          setFormDataBulkUpload={setFormDataBulkUpload}
          setMatchData={setMatchData}
          errorClose={uploadErrorClose}
          setBulkUploadTable={setBulkUploadTable}
          setBulkUploadModal={setBulkUploadModal}
          fileName={"Steam Equipment"}
          url={"/scope2/steamEquipment/steam/bulkupload"}
        />
      )}

      {bulkUploadTable && (
        <BulkUpload
          matchData={matchData}
          setMatchData={setMatchData}
          onClose={()=>setBulkUploadTable(false)}
          bulkUploadTable={bulkUploadTable}
          formData={formDataBulkUpload}
          setFormData={setFormDataBulkUpload}
          setFormDatas={setFormData}
          formDatas={formData}
          addNew={false}
          title1="Equipment Name"
          keyValue1="equipment"
          EquipmentURl={`/master/Steam/creatEquipment`}
          options1={equipmentData}
          setEquipmentData={setEquipmentData}
          bulkUploadUrl={"/scope2/steamEquipment/steam/jsonUpload"}
          setsnackOpen={setsnackOpen}
          jsonBulkUpload={formDataBulkUpload}
          matched1={"equipmentMatched"}
          onConfirm={() => {
            setBulkUploadTable(false);
            fetchData();
          }}
        />
      )}
    </Box>
  );
};

export default ElectricityConsumption;
